import { Stack, styled } from '@mui/material'
import { FlexBetween, SectionWrap, themeValue } from 'styles'
import { transientOptions } from '../../../styles/TransientOptions'
import { OrderDirection } from 'store/spot/types'

export const OrderBookWrap = styled(SectionWrap)`
  position: relative;
  height: 100%;
  min-height: 600px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    height: 275px;
    border-bottom: none;
  }
`
export const OrderbookTickerWrap = styled(Stack)`
  flex-direction: row;
  padding: 14px 0;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`
export const OrderbookLabels = styled('div')`
  display: grid;
  grid-template-columns: 95px 1fr 1fr;
  align-items: center;
  height: 24px;
  color: ${({ theme }) => theme.color.text50};
  font-size: 12px;
  line-height: 16px;
  padding: 0 16px;

  > :last-child {
    text-align: right;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
export const OrderbookList = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 16px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: row;
    height: 360px;
  }
`
export const PriceHolder = styled('div')`
  display: flex;
  gap: 2px;
  flex: 1;
  margin: 0 -4px;
  flex-direction: column;
  overflow-y: auto;
  flex-basis: 100px;
`
export const OrderbookRow = styled('div')<{ direction: OrderDirection }>`
  position: relative;
  display: grid;
  grid-template-columns: 95px 1fr 1fr;
  align-items: center;
  height: 20px;
  color: ${(props) => props.theme.color.text70};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding: 0 4px;
  position: relative;
  transition: opacity 0.2s ease;
  user-select: none;
  border-left: 2px solid;
  border-color: transparent;

  &:hover {
    cursor: pointer;
    background-color: rgba(42, 49, 57, 1);
    border-left: 2px solid;
    border-color: ${({ direction, theme }) =>
      direction === OrderDirection.LONG
        ? theme.color.buy50
        : theme.color.sell50};
  }

  &:active {
    background: ${({ theme }) => theme.color.text20};
  }

  span {
    position: relative;
  }
  > span:last-of-type {
    text-align: right;
  }
  ${(props) => props.theme.breakpoints.down('md')} {
    > span:last-of-type {
      display: none;
    }
  }
`
export const ColorBG = styled('div', transientOptions)<{
  $width: string | number
}>`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: ${({ $width }) => $width}%;
  border-radius: 2px;
`
export const ColorBGSell = styled(ColorBG)`
  background-color: rgba(144, 43, 43, 0.15);
`
export const ColorBGBuy = styled(ColorBG)`
  background-color: rgba(33, 112, 67, 0.15);
`
export const OrderDot = styled('div', transientOptions)<{
  $isBuy: boolean
}>`
  width: 4px;
  height: 4px;
  position: absolute;
  top: 8px;
  left: -2px;
  border-radius: 50%;
  background-color: ${({ theme, $isBuy }) =>
    $isBuy ? theme.color.buy50 : theme.color.sell50};

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`
export const OrderbookRowSell = styled(OrderbookRow)`
  span:first-of-type {
    color: ${({ theme }) => theme.color.sell50};
  }
  &.sell-bg-glint {
    animation: sell-bg-glint-animated 1s 1;
  }
  .tag {
    display: none;
  }

  &:hover {
    .tag {
      display: block;
    }
  }
  @keyframes sell-bg-glint-animated {
    0% {
      background-color: ${themeValue(
        'rgba(227, 85, 97, 0.2)',
        'rgba(221, 94, 86, 0.2)',
      )};
    }
    100% {
      background-color: ${themeValue(
        'rgba(227, 85, 97, 0)',
        'rgba(221, 94, 86, 0)',
      )};
    }
  }
`
export const OrderbookRowBuy = styled(OrderbookRow)`
  span:first-of-type {
    color: ${({ theme }) => theme.color.buy50};
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 0 12px;
  }
  &.buy-bg-glint {
    animation: buy-bg-glint-animated 1s 1;
  }
  .tag {
    display: none;
  }
  &:hover {
    .tag {
      display: block;
    }
  }
  @keyframes buy-bg-glint-animated {
    0% {
      background-color: ${themeValue(
        'rgba(101,186,119,0.2)',
        'rgba(72,196,142, 0.2)',
      )};
    }
    100% {
      background-color: ${themeValue(
        'rgba(101,186,119,0)',
        'rgba(72,196,142, 0)',
      )};
    }
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: row-reverse;
  }
`
export const TitleWrap = styled('div')`
  display: flex;
  height: 40px;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 12px 16px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`
export const SelectOptionStyle = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding: 8px 16px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`
export const MobileTitle = styled(FlexBetween)`
  width: 100%;
  height: 16px;
  padding: 0 16px;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  background: ${({ theme }) => theme.color.bgGray};
  color: ${({ theme }) => theme.color.text60};
  display: none;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: flex;
  }
`
